const getDataPath = (url: string): string => {
  return `${process.env.NEXT_PUBLIC_API_URL}${url}`;
};

export default getDataPath;
